<template>
  <app-popup :open="is_popup_open" :description="description"
             @dismiss="is_popup_open=false">
    <div class="columns is-variable is-4 is-align-items-flex-start">
      <div class="column is-narrow has-text-centered step-column">
        <div class="dark_circle">1</div>
        <div class="step-label">
          <b>Select ATUS years/modules</b>
        </div>
        <img :src="step1img" :alt="step_alt_text['step_1']" class="step-image"/>
      </div>
      <div class="column is-narrow has-text-centered step-column">
        <div class="dark_circle">2</div>
        <div class="step-label">
          <b>Select CPS supplement topics</b>
        </div>
        <img :src="step2img" :alt="step_alt_text['step_2']" class="step-image"/>
      </div>
      <div class="column is-narrow has-text-centered step-column">
        <div class="dark_circle">3</div>
        <div class="step-label">
          <b>Interpret the visualization</b>
        </div>
        <img :src="step3img" :alt="step_alt_text['step_3']" class="step-image"/>
      </div>
      <div class="column is-narrow has-text-centered step-column">
        <div class="dark_circle">4</div>
        <div class="step-label">
          <b>Adjust the visualization</b>
        </div>
        <img :src="step4img" :alt="step_alt_text['step_4']" class="step-image"/>
      </div>
    </div>
  </app-popup>
</template>
<script setup>
import step1img from "../images/step1_aclc.png";
import step2img from "../images/step2_aclc.png";
import step3img from "../images/step3_aclc.png";
import step4img from "../images/step4_aclc.png";
import AppPopup from "./AppPopup.vue";
import {inject} from "vue";

const is_popup_open = inject("is_popup_open");

const description = "This tool visually illustrates, for each year of ATUS data, the number of ATUS respondents " +
    "who participate in the CPS by month and year. The view can be customized by 1) selecting a subset of ATUS years " +
    "(see #1); 2) overlaying the timing of CPS supplements (see #2); and 3) adjusting the visualization to display " +
    "counts based on different windows of participation in the CPS (see #4). <span class='has-text-weight-bold'>" +
    "The default visualization shows only the number of ATUS respondents who completed their final CPS interview " +
    "(i.e., month-in-sample (MIS) eight, two to five months prior to ATUS).</span> The view can be modified to " +
    "include all ATUS respondents eligible to be interviewed in a given month and year based on the CPS rotation " +
    "pattern (e.g., MIS 1-8); these linking options display high-end estimates of the number of ATUS respondents " +
    "one could expect to observe in CPS months and years.";

const step_alt_text = {
  step_1: "Click \"Show ATUS Counts\" and check ATUS years of interest to show linking counts for those years.",
  step_2: "Click \"Show CPS Supplement Label\" and check CPS supplements to show month + year they were fielded.",
  step_3: "Locate the number by year of ATUS respondents who participated in the CPS for a given month + year.",
  step_4: "Click \"ATUS to CPS Linking Options\" to change the ATUS to CPS linking window (in months)"
}
</script>


<style>
.step-image {
  max-height: 186px; /* as width as possible without horizontal scrolling */
  width: auto; /* preserve intrinsic relative width of images */
  max-width: none; /* prevent Bulma/global overrides */
}

.step-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dark_circle {
  margin-bottom: 0.5rem; /* space below number */
}

.step-label {
  margin-bottom: 0.75rem; /* space above image */
}
</style>